module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("BKWxF"))).then(() => parcelRequire('d0iPb'));